module.exports = __webpack_public_path__ + "img/menu-all.56ae159e.jpg";